import { css } from 'styled-components';

export const CustomMaskStyles = css`
  .b-schedulerpro {
    .custom-mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: var(--white-100);
      z-index: 4;
    }
  }
`;
